import { getThemeProp } from '../../src/styled/utils';
export function groupRadius(position) {
    return (theme) => {
        const size = `${getThemeProp('borderRadius')(theme)}px`;
        if (position === 'first') {
            return `${size} 0 0 ${size}`;
        }
        if (position === 'last') {
            return `0 ${size} ${size} 0`;
        }
        if (position) {
            return '0';
        }
        return `${size}`;
    };
}
export function groupBorder(position) {
    if (position === 'last' || position === undefined) {
        return '1px';
    }
    else {
        return '1px 0 1px 1px';
    }
}
